export const hawaiiCountiesList = [
    'Hawaii',
    'Honolulu',
    'Kalawao',
    'Kauai',
    'Maui',
    ]